(() => {
  const audio = document.querySelector('#zarf-audio');
  const button = document.querySelector('#play-audio');

  if (!audio || !button) return;

  const setPlayingState = (isPlaying) => {
    button.classList.toggle('is-playing', isPlaying);
    button.setAttribute('aria-pressed', String(isPlaying));
    button.setAttribute(
      'aria-label',
      isPlaying ? 'Restart Zarf pronunciation' : 'Play Zarf pronunciation'
    );
  };

  audio.addEventListener('play', () => setPlayingState(true));
  audio.addEventListener('pause', () => setPlayingState(false));
  audio.addEventListener('ended', () => setPlayingState(false));
  audio.addEventListener('error', () => setPlayingState(false));
})();
